import React from 'react';
import './TreeFAB.css';

export default function TreeFAB({ visible, active, onClick }) {
  if (!visible) return null;
  return (
    <button
      className={`tree-fab${active ? ' tree-fab--active' : ''}`}
      onClick={onClick}
      aria-label="Toggle process tree"
      title="Process Tree Navigator"
    >
      <i className="ti ti-topology-star-3" aria-hidden="true" />
      {active && <span className="tree-fab-label">Tree</span>}
    </button>
  );
}
